module.exports = __webpack_public_path__ + "img/wallet_01_cloud.2bcc1d7d.svg";